module.exports = __webpack_public_path__ + "src/assets/img/amerisolar.021d2ec7.png";